// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".map-marker1{top:37%;left:30.5%}.map-marker2{top:78%;left:32.5%}.map-marker3{top:17.5%;left:78.8%}@media screen and (max-width:699px){.map-marker1{top:38.2%;left:33%}.map-marker2{top:70%;left:34%}.map-marker3{top:23.5%;left:70%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
